"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function hasRequiredLength(value, options, params) {
    var isValid = true;
    var errors;
    if (value.length < options.min) {
        isValid = false;
        errors = {
            constraints: {
                min: options.min.toString(),
            },
            params: [options.min.toString()],
        };
    }
    if (value.length > options.max) {
        isValid = false;
        errors = {
            constraints: {
                max: options.max.toString(),
            },
            params: [options.max.toString()],
        };
    }
    return {
        isValid: isValid,
        errors: errors,
    };
}
exports.default = hasRequiredLength;
